import { AWTPiiKind, AWTPropertyType } from '@aria/webjs-sdk'

export type REPORT_DATA = 'reportdata'
export const REPORT_DATA = 'reportdata'

export type ACTIVITY = 'activity'
export const ACTIVITY = 'activity'

export type UNEXPECTED = 'unexpected'
export const UNEXPECTED = 'unexpected'

export type TRACE = 'trace'
export const TRACE = 'trace'

export type Name = ACTIVITY | REPORT_DATA | UNEXPECTED

export enum ExpirationDate {
  Perpetual = '2099-12-31', // #Y2K #YOLO
}

export enum SamplePolicy {
  Measure = 0,
  Critical,
}

export enum Audience {
  Automation = 'Automation',
  Dogfood = 'Dogfood',
  Microsoft = 'Microsoft',
  Insiders = 'Insiders',
  Production = 'Production',
}

export interface IPrimitiveProperties { [key: string]: string | number | boolean }

export interface ICommonProperties extends IPrimitiveProperties {
  Audience: Audience
  EventName: string
  ExpirationDate: ExpirationDate | string
  Namespace: string
  SamplePolicy: SamplePolicy
  SchemaVersion: string
  ShortEventName: string
  IsExportable: string // Whether this event is exportable for GDPR purposes
}

export interface IReportDataProperties extends ICommonProperties {
  SessionCorrelationId: string
}

export interface ISignedInDataProperties extends IReportDataProperties {
  ['UserInfo.OmsTenantId']: string
}

// tslint:disable-next-line:no-empty-interface
export interface IReportDataProperties extends ICommonProperties { /* left blank */ }

export interface IUnexpectedProperties extends ICommonProperties {
  ErrorCode1: string
  ErrorCode2: string
  ErrorTag: string
  ErrorType: string
}

export interface ITraceProperties extends ICommonProperties {
  ErrorTag: string
  TraceTime: string
  TriggerError: string
  TriggerErrorCode: string
  TriggerErrorType: string
}

export interface ILogItem {
  SessionCorrelationId?: string
  ExpirationDate: ExpirationDate | string
  Namespace: string
  ShortEventName: string
  IsExportable: boolean // Whether this event is exportable for GDPR purposes
  HostApp?: string // HostApp is outside of the Common Schema, but is added to allow multiple host contexts for a single Aria tenant
}

export interface IReportDataLogItem extends ILogItem {
  Context?: IPrimitiveProperties
}

export interface IPiiEventProperty {
  Name: string,
  Value: string,
  Pii: AWTPiiKind
  Type?: AWTPropertyType
}

export interface IPiiLogItem extends IReportDataLogItem {
  PiiItems: IPiiEventProperty[]
}

export interface IUnexpectedLogItem extends ILogItem {
  ErrorCode1?: number
  ErrorCode2?: number
  ErrorTag?: string
  ErrorType?: string
  Context?: IPrimitiveProperties
}

export interface ITraceLogItem extends IReportDataLogItem {
  ErrorTag?: string
}

export interface ITraceLogBufferItem extends ITraceLogItem {
  TraceTime: string
}